var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("DatePicker", {
    attrs: {
      format: "yyyy-MM-dd",
      "disabled-dates": { customPredictor: _vm.predictDisabledDates },
    },
    on: { selected: _vm.dateSelected },
    model: {
      value: _vm.datePickerInput,
      callback: function ($$v) {
        _vm.datePickerInput = $$v
      },
      expression: "datePickerInput",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }